const API_CONFIG = {
  AUTH_SERVICE: process.env.VUE_APP_API_URL_AUTH || 'http://localhost:8005',
  TASK_SERVICE: process.env.VUE_APP_API_URL_TASK || 'http://localhost:8005',
  MAIN_SERVICE: process.env.VUE_APP_API_URL_MAIN || 'http://localhost:8005'
};

export default API_CONFIG;
